import axios from "axios"
import jwtDefaultConfig from "./jwtDefaultConfig"
import Swal from "sweetalert2"

export default class JwtService {
  // ** jwtConfig <= Will be used by this service
  jwtConfig = { ...jwtDefaultConfig }

  // ** For Refreshing Token
  isAlreadyFetchingAccessToken = false

  // ** For Refreshing Token
  subscribers = []

  constructor(jwtOverrideConfig) {
    this.jwtConfig = { ...this.jwtConfig, ...jwtOverrideConfig }

    // ** Request Interceptor
    axios.interceptors.request.use(
      (config) => {
        // ** Get token from localStorage
        const accessToken = this.getToken()
        config.headers["X-HOST"] = this.jwtConfig.xHost
        config.headers["X-lang"] = localStorage.getItem("lang")
        // ** If token is present add it to request's Authorization Header
        if (accessToken) {
          // ** eslint-disable-next-line no-param-reassign
          config.headers.Authorization = `${this.jwtConfig.tokenType} ${JSON.parse(accessToken)}`
        }
        return config
      },
      (error) => Promise.reject(error)
    )

    // ** Add request/response interceptor
    axios.interceptors.response.use(
      (response) => response,
      (error) => {
        // ** const { config, response: { status } } = error
        const { config, response } = error
        const originalRequest = config
        const accessToken = this.getToken()
        if (response?.status >= 400 && response?.status <= 500) {
          if (response?.status === 401) {
            window.location.replace("/")
            localStorage.clear()
          }
          this.showCorrectErrorMessageToUser(response, config)
        }
        return Promise.reject(error)
      }
    )
  }

  permitionManipulation() {
    Swal.fire({
      title: `<h1 style="color: white">Sizda bu xizmatdan foydalanish xuquqi mavjud emas</h1>`,
      icon: "error",
      background: "#161b2e",
      confirmButtonText: "Ok",
      allowEscapeKey: false,
      allowOutsideClick: false,
      customClass: {
        confirmButton: "btn btn-success mt-1"
      }
    })
  }

  errorsInSwall(name) {
    Swal.fire({
      background: "linear-gradient(0deg, rgba(10,24,57,0.9) 0%, rgba(3,42,214,0.9) 100%)",
      title: `<h1 style='color:white'>${name}</h1>`,
      icon: "error",
      confirmButtonText: "OK",
      allowEscapeKey: false,
      allowOutsideClick: false,
      customClass: {
        confirmButton: "btn btn-primary"
      },
      showClass: {
        popup: "animate__animated animate__rotateInDownRight"
      },
      hideClass: {
        popup: "animate__animated animate__rotateOutUpLeft"
      }
    })
  }

  showCorrectErrorMessageToUser(response, config) {
    switch (response.data.code) {
      case 400:
        Swal.fire({
          title: `<h1 style="color: white">Нотоғри маълумотлар киритилган</h1>`,
          icon: "error",
          background: "linear-gradient(0deg, rgba(10,24,57,1) 0%, rgba(3,42,214,1) 100%)",
          confirmButtonText: "Ok",
          customClass: {
            confirmButton: "btn btn-primary"
          }
        })
        break
      case 401:
        const absoluteUrl = window.location.href
        const absoluteUrlArray = absoluteUrl.split("/")
        const path = absoluteUrlArray[absoluteUrlArray.length - 1]
        localStorage.clear()
        if (path === "login") this.errorsInSwall("Логин ёки парол xaто киритилган")
        else {
          Swal.fire({
            title: `<h1 style="color: white">Сизнинг сессиянгиз тугади</h1>`,
            icon: "error",
            background: "linear-gradient(0deg, rgba(10,24,57,1) 0%, rgba(3,42,214,1) 100%)",
            confirmButtonText: "Ok",
            customClass: {
              confirmButton: "btn btn-primary"
            }
          })
          window.location.replace("/")
        }
        break
      case 403:
        this.permitionManipulation()
        break
      case 404:
        Swal.fire({
          title: `<h1 style="color: white">Маълумот топилмади</h1>`,
          icon: "error",
          background: "linear-gradient(0deg, rgba(10,24,57,1) 0%, rgba(3,42,214,1) 100%)",
          confirmButtonText: "Ok",
          customClass: {
            confirmButton: "btn btn-primary"
          }
        })
        break
      // case 500:
      //   Swal.fire({
      //     title: `<h1 style="color: white">Серверда хатолик юз берди</h1>`,
      //     icon: "error",
      //     background: "linear-gradient(0deg, rgba(10,24,57,1) 0%, rgba(3,42,214,1) 100%)",
      //     confirmButtonText: "Ok",
      //     customClass: {
      //       confirmButton: "btn btn-primary"
      //     }
      //   })
      //   break
      case 1001:
        Swal.fire({
          title: `<h1 style="color: white">Муаян кардани чеҳраҳо серверида хатолик</h1>`,
          icon: "error",
          background: "linear-gradient(0deg, rgba(10,24,57,1) 0%, rgba(3,42,214,1) 100%)",
          confirmButtonText: "Ok",
          customClass: {
            confirmButton: "btn btn-primary"
          }
        })
        break
      case 1002:
        Swal.fire({
          title: `<h1 style="color: white">Муаян кардани чеҳраҳо серверида хатолик</h1>`,
          icon: "error",
          background: "linear-gradient(0deg, rgba(10,24,57,1) 0%, rgba(3,42,214,1) 100%)",
          confirmButtonText: "Ok",
          customClass: {
            confirmButton: "btn btn-primary"
          }
        })
        break
      case 1003:
        Swal.fire({
          title: `<h1 style="color: white">Radar серверида хатолик юз берди</h1>`,
          icon: "error",
          background: "linear-gradient(0deg, rgba(10,24,57,1) 0%, rgba(3,42,214,1) 100%)",
          confirmButtonText: "Ok",
          customClass: {
            confirmButton: "btn btn-primary"
          }
        })
        break
      case 1004:
        Swal.fire({
          title: `<h1 style="color: white">Perimeter серверида хатолик юз берди</h1>`,
          icon: "error",
          background: "linear-gradient(0deg, rgba(10,24,57,1) 0%, rgba(3,42,214,1) 100%)",
          confirmButtonText: "Ok",
          customClass: {
            confirmButton: "btn btn-primary"
          }
        })
        break
        // case 1005:
        // this.errorsInSwall("Video tahlil serverida xatolik yuz berdi")
        break
      case 1006:
        Swal.fire({
          title: `<h1 style="color: white">АСБТ- транспорт хакида маълумот сервиси жавоб бермади</h1>`,
          icon: "error",
          background: "linear-gradient(0deg, rgba(10,24,57,1) 0%, rgba(3,42,214,1) 100%)",
          confirmButtonText: "Ok",
          customClass: {
            confirmButton: "btn btn-primary"
          }
        })
        break
      case 1007:
        Swal.fire({
          title: `<h1 style="color: white">ИИВ М ва ФРББ билан алоқа мавжуд емас</h1>`,
          icon: "error",
          background: "linear-gradient(0deg, rgba(10,24,57,1) 0%, rgba(3,42,214,1) 100%)",
          confirmButtonText: "Ok",
          customClass: {
            confirmButton: "btn btn-primary"
          }
        })
        break
      case 1008:
        Swal.fire({
          title: `<h1 style="color: white">ITS - хизматида хатолик юз берди</h1>`,
          icon: "error",
          background: "linear-gradient(0deg, rgba(10,24,57,1) 0%, rgba(3,42,214,1) 100%)",
          confirmButtonText: "Ok",
          customClass: {
            confirmButton: "btn btn-primary"
          }
        })
        break
      case 1009:
        Swal.fire({
          title: `<h1 style="color: white">Avtobus Tracking - хизматида хатолик юз берди</h1>`,
          icon: "error",
          background: "linear-gradient(0deg, rgba(10,24,57,1) 0%, rgba(3,42,214,1) 100%)",
          confirmButtonText: "Ok",
          customClass: {
            confirmButton: "btn btn-primary"
          }
        })
        break
      case 1010:
        // this.errorsInSwall("MyGOV (НЕДВИЖИМОСТЬ) - xizmatida xatolik yuz berdi")
        break
      case 1011:
        Swal.fire({
          title: `<h1 style="color: white">ASBT - хизматида хатолик юз берди</h1>`,
          icon: "error",
          background: "linear-gradient(0deg, rgba(10,24,57,1) 0%, rgba(3,42,214,1) 100%)",
          confirmButtonText: "Ok",
          customClass: {
            confirmButton: "btn btn-primary"
          }
        })
        break
    }
  }

  onAccessTokenFetched(accessToken) {
    this.subscribers = this.subscribers.filter((callback) => callback(accessToken))
  }

  addSubscriber(callback) {
    this.subscribers.push(callback)
  }

  getToken() {
    return localStorage.getItem(this.jwtConfig.storageTokenKeyName)
  }

  getRefreshToken() {
    return localStorage.getItem(this.jwtConfig.storageRefreshTokenKeyName)
  }

  setToken(value) {
    localStorage.setItem(this.jwtConfig.storageTokenKeyName, value)
  }

  setRefreshToken(value) {
    localStorage.setItem(this.jwtConfig.storageRefreshTokenKeyName, value)
  }

  login(...args) {
    return axios.post(this.jwtConfig.loginEndpoint, ...args)
  }

  register(...args) {
    return axios.post(this.jwtConfig.registerEndpoint, ...args)
  }

  refreshToken() {
    return axios.post(this.jwtConfig.refreshEndpoint, {
      refreshToken: this.getRefreshToken()
    })
  }
}

export const onTimerStart = (timer, runFunction) => {
  let loading = false
  return setInterval(async () => {
    if (loading) return
    try {
      loading = true
      await runFunction()
      loading = false
    } catch (err) {}
  }, timer)
}
